<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header supplement-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="$router.back()">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Дополнение к оферте</ion-title>
        <ion-buttons slot="end">
          <HeaderMessengerButton />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background privacy-content" :fullscreen="true">
      <div class="supplement-body ion-padding">
        <p class="supplement-intro">
          Настоящее дополнение к договору оферты регулирует участие в платных мероприятиях (событиях) в приложении «Лига тренеров».
        </p>

        <h2>1. Описание услуги</h2>
        <p>
          Приложение «Лига тренеров» может организовывать платные мероприятия (события). Оплата участия производится через платёжный сервис ЮKassa (ЮMoney). Приложение выступает посредником: денежные средства принимаются на счёт оператора приложения и в соответствии с договором между оператором и организатором мероприятия переводятся организатору (получателю).
        </p>

        <h2>2. Порядок оплаты</h2>
        <ul>
          <li>Пользователь регистрируется на платное событие и при необходимости выбирает тариф.</li>
          <li>После регистрации пользователь может оплатить участие, перейдя по ссылке оплаты. Оплата осуществляется в соответствии с правилами ЮKassa.</li>
          <li>Факт успешной оплаты фиксируется в приложении. При наличии технической возможности пользователю предоставляется QR-код для подтверждения оплаты и входа на мероприятие.</li>
        </ul>

        <h2>3. Возвраты</h2>
        <p>
          Возврат средств за оплаченное участие в событии осуществляется в соответствии с правилами организатора мероприятия и действующим законодательством РФ. Запрос на возврат пользователь направляет оператору или организатору (способ указан в описании события или на сайте оператора).
        </p>

        <h2>4. Согласие с условиями</h2>
        <p>
          Нажимая кнопку «Оплатить» при оплате участия в платном событии, пользователь подтверждает, что ознакомился с условиями оферты и настоящим дополнением о платных событиях и согласен с ними.
        </p>

        <p class="supplement-offer-link">
          Полный текст договора оферты:
          <a :href="offerUrl" target="_blank" rel="noopener noreferrer" class="supplement-link">{{ offerUrl }}</a>
        </p>

        <h2>5. Реквизиты исполнителя</h2>
        <div class="supplement-payee">
          <p><strong>{{ LEGAL.payee.fullName }}</strong></p>
          <p>ИНН {{ LEGAL.payee.inn }}</p>
          <p>ОГРНИП {{ LEGAL.payee.ogrnip }}</p>
          <p>{{ LEGAL.payee.address }}</p>
          <p>Тел.: {{ LEGAL.payee.phone }}</p>
          <p>E-mail: <a :href="'mailto:' + LEGAL.payee.email" class="supplement-link">{{ LEGAL.payee.email }}</a></p>
        </div>

        <p class="supplement-footer">
          © Национальная лига тренеров
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { LEGAL } from '@/config/legal';

import HeaderMessengerButton from '@/components/HeaderMessengerButton.vue';

export default defineComponent({
  name: 'OfferSupplement',
  components: {
    HeaderMessengerButton,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar
  },
  setup() {
    return {
      arrowBackOutline,
      offerUrl: LEGAL.offerUrl,
      LEGAL
    };
  }
});
</script>

<style scoped>
.supplement-header {
  background: transparent;
  box-shadow: none;
}
.supplement-header ion-toolbar {
  --background: transparent;
  --color: var(--liga-chrome-text);
}
.supplement-intro {
  margin-bottom: 1.2em;
}
.supplement-offer-link {
  margin-top: 1.5em;
}
.supplement-payee {
  margin-top: 0.5em;
}
.supplement-payee p {
  margin-bottom: 0.3em;
}
</style>
